<template>
  <div class="ccui-app-container">
    <div class="ccui-advanced-search-wrapper ccui-clearfix">
      <el-search
        :formProp="formData"
        @search="searchItem"
        :isShowSearch="isShowSearch"
        class="ccui-highsearch"
        :selectClear="true"
        :colNum="{ index: 5, sinNum: 10 }"
      >
        <div class="ccui-tab-wrapper">
          <el-button
            :type="isActive === index ? 'table-top-active' : 'table-top'"
            size="mini"
            v-for="(item, index) in focuses"
            :key="index"
            @click="changeTab(item.focus)"
          >
            <template v-if="item.focus === 'all' && totalNum !== null"
              >全部{{ isActive === 0 ? `(${totalNum})` : "" }}</template
            >
            <template v-else-if="item.focus === 'onthejob' && totalNum !== null"
              >在职在岗{{ isActive === 1 ? `(${totalNum})` : "" }}</template
            >
            <template
              v-else-if="item.focus === 'onjobbutleave' && totalNum !== null"
              >在职离岗{{ isActive === 2 ? `(${totalNum})` : "" }}</template
            >
            <template v-else-if="item.focus === 'leavejob' && totalNum !== null"
              >离职离岗{{ isActive === 3 ? `(${totalNum})` : "" }}</template
            >
          </el-button>
        </div>
        <div class="ccui-extend-btn">
          <el-button
            size="mini"
            type="primary"
            @click="jumpNew"
            icon="icon-ccui-add-sup"
            >新增人员</el-button
          >
        </div>
        <template slot="search">
          <el-input
            v-model="formData.userName"
            clearable
            searchLabel="姓名"
            placeholder="请输入姓名模糊查询"
          ></el-input>
          <el-select
            v-model="formData.sex"
            clearable
            placeholder="请选择性别查询"
            searchLabel="性别"
          >
            <el-option key="1" label="男" value="1"></el-option>
            <el-option key="2" label="女" value="2"></el-option>
          </el-select>
          <el-date-picker
            v-model="formData.birthday"
            type="date"
            searchLabel="出生日期"
            placeholder="请输入出生日期查询"
          ></el-date-picker>
          <el-select
            v-model="formData.politicalOutlook"
            clearable
            placeholder="请选择政治面貌查询"
            searchLabel="政治面貌"
          >
            <el-option
              v-for="item in politicalOutlookOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="formData.isMarried"
            clearable
            placeholder="请选择婚姻状况查询"
            searchLabel="婚姻状况"
            slot="searchItem5"
            style="width:160px"
          >
            <el-option key="1" label="未婚" value="1"></el-option>
            <el-option key="2" label="已婚" value="2"></el-option>
            <el-option key="3" label="离异" value="3"></el-option>
            <el-option key="4" label="丧偶" value="4"></el-option>
          </el-select>
          <el-input
            v-model="formData.idNum"
            clearable
            searchLabel="身份证号"
            placeholder="请输入身份证号查询"
          ></el-input>
        </template>
        <!-- 表单高级搜索 -->
        <el-input
          v-model="formData.userName"
          clearable
          searchLabel="姓名"
          placeholder="请输入姓名模糊查询"
          slot="searchItem1"
          style="width:160px"
        ></el-input>
        <el-select
          v-model="formData.sex"
          clearable
          placeholder="请选择性别查询"
          searchLabel="性别"
          slot="searchItem2"
          style="width:160px"
        >
          <el-option key="1" label="男" value="1"></el-option>
          <el-option key="2" label="女" value="2"></el-option>
        </el-select>
        <el-date-picker
          v-model="formData.birthday"
          type="date"
          searchLabel="出生日期"
          placeholder="请输入出生日期查询"
          slot="searchItem3"
          style="width:160px"
        ></el-date-picker>
        <el-select
          v-model="formData.politicalOutlook"
          clearable
          placeholder="请选择政治面貌查询"
          searchLabel="政治面貌"
          slot="searchItem4"
          style="width:160px"
        >
          <el-option
            v-for="item in politicalOutlookOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="formData.isMarried"
          clearable
          placeholder="请选择婚姻状况查询"
          searchLabel="婚姻状况"
          slot="searchItem5"
          style="width:160px"
        >
          <el-option key="1" label="未婚" value="1"></el-option>
          <el-option key="2" label="已婚" value="2"></el-option>
          <el-option key="3" label="离异" value="3"></el-option>
          <el-option key="4" label="丧偶" value="4"></el-option>
        </el-select>
        <el-input
          v-model="formData.idNum"
          clearable
          searchLabel="身份证号"
          slot="searchItem6"
          placeholder="请输入身份证号查询"
          style="width:260px"
        ></el-input>
      </el-search>
    </div>
    <div class="ccui-multifunctional-table-wrapper">
      <el-table
        v-if="tableHack"
        ref="multipleTable"
        :data="tableData"
        :fit="true"
        :row-style="setRowClass"
        :cell-style="setStyle"
        border
        class="ccui-multifunctional-table"
        @select-all="handleCheckAllChange"
        @select="handleCheckChange"
        @selection-change="handleSelectionChange"
        @header-dragend="setTableTitleWidth"
        @sort-change="changeSort"
        max-height="20000"
      >
        <el-table-column type="selection" width="28" />
        <template v-for="(table, index) in tableTheadOptions">
          <el-table-column
            v-if="table.checked"
            :fixed="table.fixed || false"
            :key="index"
            :type="table.type"
            :label="table.label"
            :min-width="table.width"
            :prop="table.prop"
            :filters="table.filters"
            :filter-method="filterMethodList[table.filterMethodName]"
            :formatter="formatterList[table.formatterName]"
            :show-overflow-tooltip="true"
          ></el-table-column>
        </template>

        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="true"
              size="mini"
              type="text"
              @click="jumpDetail(scope.$index, scope.row)"
              >查看</el-button
            >
            <el-button
              v-if="true"
              size="mini"
              type="text"
              @click="jumpEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              v-if="true"
              size="mini"
              type="text"
              @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
          <template v-slot:header>
            <div class="ccui-multifunctional-table-wrapper-operation">
              <span>操作</span>
              <el-popover
                placement="right"
                popper-class="ccui-multifunctional-table-wrapper_setting__popover"
                trigger="click"
              >
                <el-checkbox
                  v-for="(e, i) in fixedTableThead"
                  :key="i"
                  :checked="e.checked"
                  disabled
                  class="ccui-popover-disabled"
                  >{{ e.label }}</el-checkbox
                >
                <div class="ccui-popover-line"></div>
                <draggable
                  :list="unfixedTableThead"
                  class="ccui-draggable"
                  @change="handleTableChange"
                >
                  <el-checkbox-group
                    v-for="(item, index) in unfixedTableThead"
                    v-model="item.checked"
                    :key="index"
                  >
                    <el-checkbox
                      :label="item"
                      :checked="item.checked"
                      :width="item.width"
                      :title="item.label"
                      @change="handleUpdate(item, index)"
                      >{{ item.label }}</el-checkbox
                    >
                  </el-checkbox-group>
                </draggable>
                <i
                  class="el-icon-s-tools ccui-multifunctional-table-wrapper_setting__icon"
                  slot="reference"
                ></i>
              </el-popover>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="ccui-table-footer" v-show="isShowPagination">
        <div class="ccui-operation">
          <el-button
            v-show="isSelection"
            size="mini"
            type="default"
            @click="handleDelSelected"
            style="margin-right:10px"
            >批量删除</el-button
          >
          <el-export-button
            placement="bottom"
            @export-excel="handleExport"
            @export-pdf="handleExport('all')"
          ></el-export-button>
        </div>
        <div id="ccui-paging">
          <el-pagination
            :total="totalNum"
            :page-size="getLocalPageSize()"
            :current-page="pageNoCode"
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
          <el-button
            class="ccui-pagination-btn"
            size="mini"
            type="default"
            @click="handleSizeChange('none')"
            >确定</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import peopleManageMixin from "../mixins/peopleManage.js";
export default {
  name: "peoplemanage-tab-item-list-leavejob",
  mixins: [peopleManageMixin],
  data() {
    return {
      isActive: 1,
      workStatus: 1
    };
  },
  methods: {
    setBreadcrumb() {
      this.$store.dispatch("setBreadcrumb", [
        {
          level: "level2",
          data: {
            name: "主子表增删改查(多页签)",
            path: "/list-query/peoplemanage/item-list-all"
          }
        },
        {
          level: "level3",
          data: {
            name: "在职在岗",
            path: "/list-query/peoplemanage/item-list-onthejob"
          }
        }
      ]);
    }
  }
  // beforeRouteLeave(to, from, next) {
  //   for(var key in this.$vnode.parent.componentInstance.cache){
  //       delete  this.$vnode.parent.componentInstance.cache[ishasAgentId(to.path,key)];
  //   }
  // }
};
</script>
